let googlePlacesPromise = null;

/**
 * Lazily loads the Google Places API by injecting a script tag.
 * Subsequent calls return the same promise to avoid duplicate loading.
 */
function loadGooglePlaces(gmaps) {
    if (window.google?.maps?.places) {
        return Promise.resolve();
    }

    if (!googlePlacesPromise) {
        googlePlacesPromise = new Promise((resolve) => {
            window._googlePlacesReady = resolve;

            const script = document.createElement('script');
            script.id = 'google-places-js';
            script.async = true;
            script.src = `${gmaps}&callback=_googlePlacesReady`;
            document.head.appendChild(script);
        });
    }

    return googlePlacesPromise;
}

function registerAlpineComponent() {
    Alpine.data('googleAutocomplete', ({ setStateUsing, statePath, gmaps }) => ({
        autocomplete: null,

        init() {
            loadGooglePlaces(gmaps).then(() => this.createAutocomplete());
        },

        destroy() {
            if (this.autocomplete) {
                google.maps.event.clearInstanceListeners(this.autocomplete);
            }
        },

        createAutocomplete() {
            const input = this.$el.querySelector('input');

            this.autocomplete = new google.maps.places.Autocomplete(input, {
                fields: ['formatted_address'],
            });

            this.autocomplete.addListener('place_changed', () => {
                const place = this.autocomplete.getPlace();

                if (place?.formatted_address) {
                    setStateUsing(statePath, place.formatted_address);
                }
            });

            input.addEventListener('change', () => {
                setStateUsing(statePath, input.value || null);
            });
        },
    }));
}

// Register immediately if Alpine is already available, otherwise wait for it to initialise.
if (window.Alpine) {
    registerAlpineComponent();
} else {
    document.addEventListener('alpine:init', registerAlpineComponent);
}
